export interface ExcelImportSharedDialogModel {
	onCancel?: () => void,
	onSave?: (isShared: boolean) => Promise<void>
}

export class ExcelImportSharedDialog implements ExcelImportSharedDialogModel {
	public onCancel?: () => void;
	public onSave?: (isShared: boolean) => Promise<void>;

	public activate(model: ExcelImportSharedDialogModel) {
		this.onCancel = model.onCancel;
		this.onSave = model.onSave;

		if (!this.onCancel) {
			this.onCancel = () => {};
		}

		if (!this.onSave) {
			this.onSave = () => new Promise<void>((resolve) => resolve());
		}
	}
}
